import axios from 'axios';

const clienteAxios = axios.create({
  baseURL: '/'
});
// baseURL: 'https://api.parquemonchis.com',
// baseURL: 'http://localhost:5016',

// Interceptor para agregar el token en cada solicitud si existe
clienteAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // Añadir el token al encabezado
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default clienteAxios;
